import { LegalRepository } from '@lib/api/repository/legal/legal.repository';
import { LegalDocument, LegalState } from '@lib/types/legal';

import { Requester } from '../clients';

const mapDocument = (d: LegalDocument): LegalDocument => ({
  publishedAt: d.publishedAt,
  effectiveAt: d.effectiveAt,
  id: d.id,
  documentVersion: d.documentVersion,
  terms: d.terms.map((s) => ({
    id: s.id,
    title: s.title,
    paragraphs: [...s.paragraphs],
  })),
  privacy: d.privacy.map((s) => ({
    id: s.id,
    title: s.title,
    paragraphs: [...s.paragraphs],
  })),
  summary: [...d.summary],
});

const mapState = (s: LegalState): LegalState => ({
  document: mapDocument(s.document),
  acceptanceRevision: s.acceptanceRevision,
  acceptedRevision: s.acceptedRevision,
  acceptedAt: s.acceptedAt,
  publishedAt: s.publishedAt,
  effectiveAt: s.effectiveAt,
  requiresAcceptance: s.requiresAcceptance,
  restricted: s.restricted,
});

export default class LegalAPI implements LegalRepository {
  async current(signal?: AbortSignal) {
    return mapState(
      (await Requester.get<LegalState>('/legal/current', { signal })).data,
    );
  }

  async status(signal?: AbortSignal) {
    return mapState(
      (await Requester.get<LegalState>('/legal/status', { signal })).data,
    );
  }

  async document(id: string, signal?: AbortSignal) {
    return mapDocument(
      (
        await Requester.get<LegalDocument>(
          `/legal/documents/${encodeURIComponent(id)}`,
          { signal },
        )
      ).data,
    );
  }

  async accept(revisionId: string) {
    return mapState(
      (
        await Requester.post<LegalState>('/legal/accept', {
          body: { revisionId, accepted: true },
        })
      ).data,
    );
  }
}
